import _extends from "@babel/runtime/helpers/esm/extends";
import { getType } from 'typesafe-actions';
import { toErrorType } from '@swuif/utils';
import { authActions } from './actions';
export var initialState = {
  isLoading: true,
  isAuthenticated: false,
  isGuestModeEnabled: false,
  credential: undefined,
  error: undefined,
  hasLogin: false,
  loginPath: '/auth/login',
  hasRegister: false,
  registerPath: '/auth/register',
  hasForgot: false,
  forgotPath: '/auth/forgot'
};
export var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(authActions.isAuthenticated):
      return _extends({}, state, {
        isAuthenticated: action.payload
      });

    case getType(authActions.guestMode):
      return _extends({}, state, {
        isGuestModeEnabled: action.payload
      });

    case getType(authActions.setCredential):
      return _extends({}, state, {
        credential: action.payload,
        isAuthenticated: action.payload != null
      });

    case getType(authActions.setError):
      return _extends({}, state, {
        error: toErrorType(action.payload.error, action.payload.source)
      });

    case getType(authActions.auth.request):
      return _extends({}, state, {
        error: undefined,
        isLoading: true
      });

    case getType(authActions.auth.success):
      return _extends({}, state, {
        credential: state.credential && action.payload ? _extends({}, state.credential, {
          user: _extends({}, state.credential.user, action.payload.user)
        }) : action.payload,
        isAuthenticated: action.payload != null,
        isLoading: false
      });

    case getType(authActions.auth.failure):
      return _extends({}, state, {
        credential: undefined,
        isAuthenticated: false,
        isLoading: false,
        error: toErrorType(action.payload, 'authentication')
      });

    case getType(authActions.setLogin):
      var _action$payload = action.payload,
          hasLogin = _action$payload.hasLogin,
          loginPath = _action$payload.loginPath;
      return _extends({}, state, {
        hasLogin: hasLogin,
        loginPath: loginPath || state.loginPath
      });

    case getType(authActions.setRegister):
      var _action$payload2 = action.payload,
          hasRegister = _action$payload2.hasRegister,
          registerPath = _action$payload2.registerPath;
      return _extends({}, state, {
        hasRegister: hasRegister,
        registerPath: registerPath || state.registerPath
      });

    case getType(authActions.setForgot):
      var _action$payload3 = action.payload,
          hasForgot = _action$payload3.hasForgot,
          forgotPath = _action$payload3.forgotPath;
      return _extends({}, state, {
        hasForgot: hasForgot,
        forgotPath: forgotPath || state.forgotPath
      });

    default:
      return state;
  }
};